/**
 * Every TanStack Query key used by the Calibration module.
 *
 * Scoped to this feature rather than the workspace — same convention as
 * `apps/agent-tools` and `apps/integration-builder`, which each keep their own
 * `QK`. Centralising them keeps one naming shape and makes prefix invalidation
 * (`QK.calibration.runs.all`) reach the list and every detail entry at once.
 *
 * Anything the backend scopes by bot takes `botId` as part of the key. The
 * request headers already carry `x-bot-id`, so a key without it lets a bot
 * switch serve the previous bot's cached response.
 */
export const QK = {
  calibration: {
    runs: {
      all: ['calibration', 'runs'] as const,
      list: (botId: string | null | undefined) => ['calibration', 'runs', botId] as const,
      detail: (runId: string) => ['calibration', 'runs', 'detail', runId] as const,
    },
    eventStatus: (botId: string | null | undefined) =>
      ['calibration', 'event-status', botId] as const,
    metrics: (botId: string | null | undefined) => ['calibration', 'metrics', botId] as const,
    // No botId: this query only runs in standalone dev (`enabled: isEP &&
    // !isFederated()`), where there is a single bot and no host to switch it.
    // Under federation the ladder is read from @frontend-platform/host-state instead.
    environments: ['calibration', 'environments'] as const,
  },
} as const;
